class MatchStatistics {
  list = [
    { order: 1, name: 'Tir cadré', match: 'shotIn' },
    { order: 2, name: 'Tir non cadré', match: 'shotOut' },
    { order: 3, name: 'Coup-francs', match: 'freekick' },
    { order: 4, name: 'Corners', match: 'corner' },
    { order: 5, name: 'Hors-jeux', match: 'offside' },
    { order: 6, name: 'Fautes', match: 'foul' }
  ]
}

const matchStatistics = new MatchStatistics()

export { matchStatistics }
